import h from 'react-hyperscript';

const setAttributes = (elementName, options) => {
  const attrs = {
    id: null,
    className: elementName,
  };

  if (options.to) {
    attrs.to = `${options.to}`;
  }

  if (options.id) {
    attrs.id = `${options.id}`;
  }

  if (options.className) {
    attrs.className = `${elementName} ${options.className}`;
  }

  if (options.type) {
    attrs.className = attrs.className.concat(`
      ${elementName}--${options.type}
    `);
  }

  if (options.material) {
    attrs.className = attrs.className.concat(` ${elementName}--has-icon`);
  }

  if (options.dangerouslySetInnerHTML) {
    attrs.dangerouslySetInnerHTML = {__html: options.dangerouslySetInnerHTML};
  }

  return attrs;
};

export const h1 = (props) => {
  const attributes = setAttributes('h1', props);
  return (
    h('h1', attributes, props.children)
  );
};

export const h2 = (props) => {
  const attributes = setAttributes('h2', props);
  return (
    h('h2', attributes, props.children)
  );
};

export const h3 = (props) => {
  const attributes = setAttributes('h3', props);
  return (
    h('h3', attributes, props.children)
  );
};

export const h4 = (props) => {
  const attributes = setAttributes('h4', props);
  return (
    h('h4', attributes, props.children)
  );
};

export const p = (props) => {
  const attributes = setAttributes('p', props);
  return (
    h('p', attributes, props.children)
  );
};

export const footnote = (props) => {
  const attributes = setAttributes('p', props);
  attributes.className = attributes.className.concat(' footnote');
  return (
    h('p', attributes, props.children)
  );
};

export const subhead = (props) => {
  const attributes = setAttributes('p', props);
  attributes.className = attributes.className.concat(' subhead');
  return (
    h('p', attributes, props.children)
  );
};

export const eyebrow = (props) => {
  const attributes = setAttributes('p', props);
  attributes.className = attributes.className.concat(' eyebrow');
  return (
    h('p', attributes, props.children)
  );
};

export const caption = (props) => {
  const attributes = setAttributes('p', props);
  attributes.className = attributes.className.concat(' caption');
  return (
    h('p', attributes, props.children)
  );
};
